import ChatBubble from '../molecules/chatBubble'
import ChatInput from '../atoms/chatInput'
import { useEffect, useReducer, useRef } from 'react'
import { getDefaultAvatarURL } from '../../constants'

const reducerMessages = (state,action) => {
  switch (action.type) {
    case "INITIAL":
      return action.messages
    case "APPEND":
      return [...state, action.message]
    default:
      return state
  }
}

const ChatContainer = ({ socket }) => {
  const [messages, dispatchMessages] = useReducer(reducerMessages,[])

  useEffect(() => {
    if(socket.nsp === "null") return null;
    socket.on('data', (data) => {
    if(data.messages){
      dispatchMessages({type: "INITIAL", messages: data.messages});
    } 
    });

    socket.on('message', (data) => {
      dispatchMessages({type: "APPEND", message: data.message});
    })
  }, [socket])

  const messagesEndRef = useRef(null)

  const scrollToBottom = () => {
    messagesEndRef.current?.scrollIntoView({ behavior: "smooth" })
  }

  useEffect(() => {
    scrollToBottom()
  }, [messages]);

  const handleSend = (msg) => {
    const { uuid, username, ip } = JSON.parse(localStorage.getItem('user'))
    socket.emit('message', { nick: username, uid: uuid, message: msg, clientIP: ip })
    const myAvatar = JSON.parse(localStorage.getItem('user')).avatar || getDefaultAvatarURL(username);
    dispatchMessages({type: "APPEND", message: {
      nick: username,
      message: msg,
      avatar: myAvatar,
    }});
  }
  console.log(messages)

  return (
    <div className="relative">
      {messages.map(({ message, nick, avatar }, i) => (
        <ChatBubble key={i + nick} msg={message} user={nick} avatar={avatar} time="now" />
      ))}
      <ChatInput send={handleSend}  />
      <div ref={messagesEndRef} />
    </div>
  )
}

export default ChatContainer
